import React from "react";

/**
 * Small theme-aware switch. Purely presentational — parent owns the state
 * (instant-save happens in useUserPermissionConfig).
 */
const Toggle = ({ checked, onChange, theme, disabled = false, size = "small" }) => {
  const isSmall = size === "small";
  const width = isSmall ? 36 : 48;
  const height = isSmall ? 20 : 26;
  const knob = height - 4;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      disabled={disabled}
      onClick={(e) => { e.stopPropagation(); if (!disabled) onChange?.(!checked); }}
      style={{
        width, height,
        borderRadius: height / 2,
        border: "none",
        padding: 0,
        cursor: disabled ? "not-allowed" : "pointer",
        position: "relative",
        flexShrink: 0,
        opacity: disabled ? 0.5 : 1,
        transition: "background 0.25s ease",
        background: checked
          ? (theme === "dark"
              ? "linear-gradient(135deg,#10b981,#059669)"
              : "linear-gradient(135deg,#34d399,#10b981)")
          : (theme === "dark" ? "rgba(100,120,150,0.35)" : "rgba(180,192,214,0.55)"),
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 2,
          // logical positioning: mirrors automatically under document.dir=rtl
          insetInlineStart: checked ? width - knob - 2 : 2,
          width: knob, height: knob,
          borderRadius: "50%",
          background: "#ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
          transition: "inset-inline-start 0.25s cubic-bezier(0.4,0,0.2,1)",
        }}
      />
    </button>
  );
};

export default Toggle;
